import angular from 'angular';
import { FeatureCouponsServiceModule } from './coupons/coupons.service';
import { FeatureCustomersServiceModule } from './customers/customers.service';
import { FeatureObjectLockServiceModule } from './objectLock/objectLock.service';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/feature/feature.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * The sub-service module shells + 'acme.common.service.themesHelper' deps are
 * preserved for module-graph parity (consumers depend on FeatureServiceModule).
 */
export { FeatureService } from '@ng/core/feature/feature.service';

export const FeatureServiceModule = angular.module('acme.common.service.feature', [
  FeatureObjectLockServiceModule,
  FeatureCustomersServiceModule,
  FeatureCouponsServiceModule,
  'acme.common.service.themesHelper',
]).name;
